module.exports = __webpack_public_path__ + "img/BackCycle.51bef384.svg";